import axios from 'axios';

export async function ResetPasswordSendEmailApi(email, params) {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_SERVICE}/backend-service/v1/reset-password/${email}`, params, { withCredentials: true})
    return response;
  } catch (error) {
    return error.response;
  }
}

